import * as React from 'react';

import { useTranslation } from 'react-i18next';

import { AddOnboardingEntitiesModal } from '@/modules/onboarding/common/components/add-entities-modal/add-onboarding-entities-modal';
import { EntityField } from '@/modules/onboarding/common/components/add-entities-modal/types';

import { useUpsertClients } from '../../hooks/use-upsert-clients';
import { ClientsFormData, getClientsSchema } from './schema';

export interface AddClientsModalProps {
  baseKey?: string;
  onSuccess?: (addedCount: number) => void;
}

export const AddOnboardingClientsModal: React.FC<AddClientsModalProps> = ({
  baseKey = '',
  onSuccess,
}) => {
  const { t } = useTranslation();
  const upsertClientsMutation = useUpsertClients({ onSuccess });

  const schema = getClientsSchema(t);

  const defaultClientValues = {
    fullName: '',
  };

  const clientFields: EntityField[] = [
    {
      name: 'fullName',
      label: t('authenticated.onboarding.clients:addModal.name'),
      placeholder: t('authenticated.onboarding.clients:addModal.name'),
    },
  ];

  const transformData = (formData: ClientsFormData) => {
    return {
      items: formData.entities.map(client => ({
        name: client.fullName,
      })),
    };
  };

  return (
    <AddOnboardingEntitiesModal
      schema={schema}
      fields={clientFields}
      mutation={upsertClientsMutation.mutateAsync}
      transformData={transformData}
      defaultEntityValues={{
        entities: [defaultClientValues],
      }}
      baseKey={baseKey}
      buttonLabel={t('authenticated.onboarding.clients:addModal.addClients')}
      modalTitle={t('authenticated.onboarding.clients:addModal.addClients')}
      addMoreLabel={t('authenticated.onboarding.clients:addModal.addMore')}
      submitLabel={t('authenticated.onboarding.clients:addModal.addClients')}
    />
  );
};
